import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CampaignFormService } from 'app/campaign/services/campaign-form.service';
import { CampaignService } from 'app/campaign/services';
import { Store } from '@ngrx/store';
import { select } from '@ngrx/store';
import { selectCampaignSelected } from 'app/campaign/features/campaign.selectors';

@Component({
  selector: 'app-campaign-peer-to-peer-fundraising-settings',
  templateUrl: './campaign-peer-to-peer-fundraising-settings.component.html',
  styleUrls: ['./campaign-peer-to-peer-fundraising-settings.component.scss']
})
export class CampaignPeerToPeerFundraisingSettingsComponent implements OnInit, OnDestroy {

  @Input() formGroupCampaignTypeData: UntypedFormGroup = null;
  @Input() submitted: boolean = false;

  public campaign: UntypedFormGroup = null;
  public takeUntilSubject: Subject<any> = new Subject();

  public closingDateTimeUnixOptions: any = {
    dateFormat: 'mm/dd/yyyy'
  };

  public closingDateTimeUnixRequired: boolean = false;

  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );

  constructor(
    public campaignService: CampaignService,
    public campaignFormService: CampaignFormService,
    private store: Store
  ) {
  }

  ngOnInit(): void {
    this.campaign = this.campaignFormService.form;
    this.formGroupCampaignTypeData.get('useAmounts').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(()=>{
      let useAmounts = this.formGroupCampaignTypeData.get('useAmounts');
      let usePercentage =  this.formGroupCampaignTypeData.get('usePercentage')
      if (useAmounts.value === true) {
        usePercentage.setValue(false)
      }
    })

    this.formGroupCampaignTypeData.get('usePercentage').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(()=>{
      let useAmounts = this.formGroupCampaignTypeData.get('useAmounts');
      let usePercentage =  this.formGroupCampaignTypeData.get('usePercentage')
      if (usePercentage.value === true) {
        useAmounts.setValue(false)
      }
    })

    const pledgePerEvent = this.formGroupCampaignTypeData.get('pledgePerEvent');
    const maxEventCount = this.formGroupCampaignTypeData.get('maxEventCount');
    const eventName = this.formGroupCampaignTypeData.get('eventName');

    pledgePerEvent.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value)=>{
      this.closingDateTimeUnixRequired = value;

      const usePercentage = this.formGroupCampaignTypeData.get('usePercentage');
      if(value) {
        usePercentage.setValue(false);
        usePercentage.disable();
      } else {
        usePercentage.enable();
      }
    })

    this.campaignService.configGroup(this.formGroupCampaignTypeData, this.formGroupCampaignTypeData, 'pledgePerEvent', [
      { name: 'maxEventCount', defaultValue: 0, validators: [Validators.required, Validators.min(1)] },
    ], this.takeUntilSubject);

    this.campaignService.configGroup(this.formGroupCampaignTypeData, this.formGroupCampaignTypeData, 'pledgePerEvent', [
      { name: 'eventName', defaultValue: "", validators: [Validators.required] },
    ], this.takeUntilSubject);

    this.campaign$.pipe(
      filter(campaign => campaign !== null),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      if(pledgePerEvent.value) {
        this.closingDateTimeUnixRequired = true;
        
        maxEventCount.setValidators([Validators.required, Validators.min(1)]);
        eventName.setValidators([Validators.required]);
      }
    });
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
